import type { ReactNode } from "react";
import { createContext } from "react";
import { I18nProvider as ReactAriaI18nProvider } from "react-aria-components";

import { NcRouterProvider } from "./nc-router-provider";

const defaultValue = {
  t: (value: string) => value,
  locale: "en-NZ",
};

type NcGlobalContextValue = {
  t: (value: string, params?: { [key: string]: string }) => string;
  locale: string;
};

export const NcGlobalContext = createContext<NcGlobalContextValue>(defaultValue);

export const NcGlobalProvider = ({
  value,
  children,
}: {
  value: NcGlobalContextValue;
  children: ReactNode;
}) => (
  <NcGlobalContext.Provider value={value}>
    <ReactAriaI18nProvider locale={value.locale}>
      <NcRouterProvider>{children}</NcRouterProvider>
    </ReactAriaI18nProvider>
  </NcGlobalContext.Provider>
);
